import React, { Component } from "react";
import { connect } from "react-redux";

// Components
import Loader from "../../utils/Loader";
import BillingAddressSelection from "./BillingAddressSelection";
import LocationMap from "../../utils/maps/LocationMap";

// State
import { getBillingAddresses } from "../../../store/actions/billingAddress";

class BillingAddressModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			mapAddress: "",
			showMap: false
		};
	}

	componentDidMount() {
		this.props.getBillingAddresses();
	}

	handleMap(address) {
		this.setState({
			mapAddress: address,
			showMap: true
		});
	}

	render() {
		return this.props.isLoading ? (
			<div className="pt1 pb1">
				<Loader />
			</div>
		) : this.state.showMap ? (
			<LocationMap address={this.state.mapAddress} loadingElement={<Loader />} googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyA2mfXsrW3E8ZKx7pxKPFBRy-qE-wAEgOg&libraries=places" />
		) : this.props.addresses.length ? (
			this.props.addresses.map((address, i) => <BillingAddressSelection key={i} address={address} mapHandler={this.handleMap.bind(this)} handleSelect={this.props.handleSelect} />)
		) : (
			<div className="">You have no addresses saved.</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		addresses: state.billingAddress.addresses,
		isLoading: state.billingAddress.isLoading,
		error: state.billingAddress.error
	};
};

export default connect(mapStateToProps, { getBillingAddresses })(BillingAddressModal);



// WEBPACK FOOTER //
// ./src/components/checkout/billing/BillingAddressModal.js